var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 599,
    height: 30,
    viewBox: "0 0 599 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3269_4191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M599 -36L599 11.1955L302.229 28L-2.06298e-06 11.1955L0 -36L599 -36Z",
    fill: "#16304F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3269_4191"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 599,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomShape);
export default __webpack_public_path__ + "static/media/bottom-shape.93b544a4004b9df4671787b6f1b19939.svg";
export { ForwardRef as ReactComponent };